module.exports = __webpack_public_path__ + "assets/img/26_732.b08dd81a.jpg";